<kendo-dialog [title]="'are-you-sure' | t7e" (close)="onCancelled()">
  <div class="popup-content">
    <div class="explanation">
      {{ t7eExplanationText }}
    </div>
    <div class="no-days" *ngIf="!(ts_ForPage$ | async)?.length"
      t7e="no-days">
    </div>
    <div class="days" *ngFor="let ts of ts_ForPage$ | async">
      <h1>{{ ts.dStartDate | date:DATE_FORMAT | titlecase }}</h1>
      <h2>{{ ts.dStartDate | date:TIME_FORMAT }} - {{ ts.dEndDate | date:TIME_FORMAT }}</h2>
      <div class="fees">
        <app-ts-editor-readonly field="calc" [ts]="ts" [showSalaryReasons]="false"></app-ts-editor-readonly>
      </div>
    </div>
    <div *ngIf="debug">
      {{ ts_ForPage$ | async | json }}
    </div>
  </div>

  <kendo-dialog-actions>  
    <button mat-raised-button (click)="onCancelled()">
      {{ 'cancel' | t7e }}
    </button>
    <button mat-raised-button (click)="onConfirmed()" color="primary">
      {{ 'submit' | t7e }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>